import { Fragment } from 'react';

import { FilterFieldConfig, resolveFilterInput } from 'shared/mui/Filter/config';

type FilterFieldsProps = {
  fields: FilterFieldConfig[];
};

export const FilterFields: React.FC<FilterFieldsProps> = ({ fields }) => (
  <>
    {fields.map((field) => (
      <Fragment key={field.name}>{resolveFilterInput(field.input, 'field') ?? null}</Fragment>
    ))}
  </>
);
